import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Role} from '../model/role';
import {SharedPreference} from '../shared-preference/shared-perference';
import {dashboardUrl, orderListUrl, profile, requestDemoUrl, bussinessConfigurationUrl} from '../inventory/route';
import {AuthenticationService} from '../services/authentication.service';
import {UserAccessUtils} from "../utils/user-access-utils";
import {GuardUtils} from "../utils/guard";

@Injectable({
  providedIn: 'root'
})
export class OrdersGuardService implements CanActivate{
  constructor(private router: Router, private authenticationService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (!SharedPreference.getUser()) {
      this.authenticationService.onLogout(false);
      return false;
    }

    if (Role.hasVersitaCustomerService(SharedPreference.getUser()) || Role.hasVersitaSupervisor(SharedPreference.getUser())) {
      if (SharedPreference.getUser().isRequireChangePassword) {
        this.router.navigate([profile]);
        return false;
      } else {
        return true;
      }
    }

    if (SharedPreference.getUser().isRequireChangePassword) {
      this.router.navigate([profile]);
      return false;
    } else {
      if((SharedPreference.getUser().roles.length == 1 && Role.hasAdminRole(SharedPreference.getUser())) || Role.hasVersitaSystem(SharedPreference.getUser())){
        if (Role.hasVersitaSystem(SharedPreference.getUser())){
          this.router.navigate([bussinessConfigurationUrl]);
        }else {
          this.router.navigate([dashboardUrl]);
        }
        return false;
      } else if (Role.hasVersitaSale(SharedPreference.getUser())) {
        this.router.navigate([requestDemoUrl]);
        return false;
      } else {
        const hasAccess = UserAccessUtils.isUserAllowOrderTracking(SharedPreference.getUser()) || Role.hasVersitaAdmin(SharedPreference.getUser()) || Role.hasVersitaSupervisor(SharedPreference.getUser());
        return GuardUtils.handleAccessControl(hasAccess, this.router, state);
      }
    }

  }
}
